//import { useState } from "react";
//import SubmitButton from "../submitButton/SubmitButton";
import { useTranslator } from "../../context/translator";

const Settings = () => {
  const { updatePreference, preferredLanguage } = useTranslator();
  // const [isLoading] = useState(false);
  const { translate } = useTranslator();
  const handleSubmitSettings = (e) => {};

  const onChangeLang = (e) => {
    updatePreference(e.target.value);
  };

  return (
    <form onSubmit={handleSubmitSettings} className="w-full">
      <div className="max-w-sm mb-6">
        <label
          htmlFor="lang"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          {translate("select-an-language")}
        </label>
        <select
          id="lang"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          value={preferredLanguage}
          onChange={onChangeLang}
        >
          <option value="es">Español</option>
          <option value="en">English</option>
        </select>
      </div>
    </form>
  );
};

export default Settings;

/*
<div className="hidden">
        <div className="mb-6">
          <label
            htmlFor="username"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Username
          </label>
          <input
            type="text"
            id="username"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Username"
            disabled
            value={"steven"}
          />
        </div>
        <div className="mb-6">
          <div className="grid gap-6 mb-6 md:grid-cols-2">
            <div>
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="•••••••••"
                required
              />
            </div>
            <div>
              <label
                htmlFor="confirm_password"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Confirm password
              </label>
              <input
                type="password"
                id="confirm_password"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="•••••••••"
                required
              />
            </div>
          </div>
        </div>
      </div>

            <div className="mt-5">
        <div className="flex justify-end">
          <SubmitButton
            isLoading={isLoading}
            textLoading="Saving..."
            text={"Save"}
          />
        </div>
      </div>
*/
